import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SpfBucketFileFrontend } from '@shared/index';
import { ImageGenerateParams } from 'openai/resources';
import QueryString from 'qs';
import { firstValueFrom } from 'rxjs';
import { EventManagerAdminService } from '../../event-manager/event-manager-admin.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';
import { UsertokenService } from '@shared-angular/services/usertoken.service';

export type AiImageFile = SpfBucketFileFrontend<{
  userId: string,
  botId: string,
  created: Date,
  lastAccess: Date,
  prompt: string
}>

@Injectable({
  providedIn: 'root'
})
export class OpenaiImageService {
  constructor(
    private eventManager: EventManagerAdminService,
    private http: HttpClient,
    private botIdService: BotidService,
    private usertokenService: UsertokenService
  ) { }

  public async create(prompt: string, opts: Omit<ImageGenerateParams, "prompt" | "style"> & { image?: string, images?: string[], aspectRatio?: string } = {}) {
    this.eventManager._trigger_RAGAI_EVENT("RAGAI.AIIMAGE_OPENAI.CREATE.start", { prompt, opts });

    const query = QueryString.stringify({
      prompt,
      ...opts,
      ...(opts.images && { images: JSON.stringify(opts.images) })
    });
    const result = await firstValueFrom(this.http.get<AiImageFile>("/api/ai/image/create/openai/" + this.botIdService.getBotId() + "?" + query));
    this.eventManager._trigger_RAGAI_EVENT("RAGAI.AIIMAGE_OPENAI.CREATE.done", { prompt, opts, result });


    return result;
  }

  public getImageUrl(fileId: string) {
    return "/api/ai/image/load/" + this.botIdService.getBotId() + "/" + fileId + "?Ut=" + this.usertokenService.getUserToken();
  }

  public async analyzeImage(image: string, prompt: string) {
    this.eventManager._trigger_RAGAI_EVENT("RAGAI.AIIMAGE_OPENAI.ANALYZEIMAGE.start", { image, prompt });
    const result = await firstValueFrom(this.http.post<string>('/api/user/image/analyze/' + this.botIdService.getBotId(), { text: prompt, image }));
    this.eventManager._trigger_RAGAI_EVENT("RAGAI.AIIMAGE_OPENAI.ANALYZEIMAGE.done", { image, prompt, result });
    return result;
  }
}
